<template>
  <nav class="breadcrumb">
    <ul>
      <li>
        <router-link to="/plans" class="root">Plans</router-link>
      </li>
      <li v-for="(crumb, index) in crumbs" v-bind:key="index">
        <router-link v-if="crumb.link" v-bind:to="crumb.link">{{ crumb.name }}</router-link>
        <p v-else>
          <Star v-if="crumb.starFlag" position="top-right" />
          {{ crumb.name }}
        </p>
      </li>
    </ul>
  </nav>
</template>

<script>
import Star from '@/components/Star.vue'

export default {
  props: {
    crumbs: Array
  },
  name: 'Breadcrumb',
  components: {
    Star
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
nav.breadcrumb {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 70px;

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0 0 25px;
  }

  li {
    display: inline-block;
    height: 24px;
    padding: 0 14px 0 0;
    margin: 0 7px 0 0;
    background: url('../assets/icons/breadcrumb-arrow.png') no-repeat center right;

    &:last-child {
      background: none;
    }
  }

  a {
    display: inline-block;
    @extend %type-epsilon;
    line-height: 24px;
    color: $text-alpha;
    font-weight: $bold;
    text-decoration: none;

    &.root {
      font-weight: $semi-bold;
    }
  }

  .star {
    vertical-align: -7%;
    font-size: 18px;
  }
}
</style>
